import React, { useEffect } from "react";
import "../assets/styles/Contact.scss";
import EmailIcon from "@mui/icons-material/Email";
import AOS from "aos";
import "aos/dist/aos.css";
// import PhoneIcon from "@mui/icons-material/Phone";
// import LocationOnIcon from "@mui/icons-material/LocationOn";

const Contact: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="contact-container" id="contact">
      <div className="final-cta-banner" data-aos="fade-up">
        <h3>Goal Guru – Your Personalized Football Companion</h3>
        <p>
          Say goodbye to endless notifications and hello to football alerts that
          actually matter. Goal Guru is a smart, personalized football tracking
          app that learns what you care about and delivers updates tailored just
          for you. From your favorite leagues and teams to the games that truly
          deserve your attention, we make sure you never miss the moments that
          excite you the most.
        </p>
        <p>
          Unlike other apps that flood you with generic alerts, Goal Guru
          focuses on quality over quantity. With the help of AI, we analyze your
          preferences, alert history, and trends to understand what’s important
          to you—and then suggest the matches and events that matter.
        </p>
        <p>
          Right now, we create smart alerts with the help of users, letting you
          customize notifications and control their frequency. Soon, our
          personalization engine will go even further: automatically learning
          your interests, surfacing the games most likely to matter to you, and
          guiding you toward the most exciting football action — a step toward
          fully personalized sports intelligence.
        </p>
        <p className="highlight-text">
          <strong>
            Goal Guru isn’t just another sports app—it’s your personal football
            assistant, designed to make every match count.
          </strong>
        </p>
      </div>

      <h2>Contact Us</h2>
      <p>
        <EmailIcon className="contact-icon" />
        Email: <a href="mailto:support@goalguru.live">support@goalguru.live</a>
      </p>
      {/* <p>
        <PhoneIcon className="contact-icon" />
        Phone: <a href="tel:+1234567890">+1 (234) 567-890</a>
      </p>
      <p>
        <LocationOnIcon className="contact-icon" />
        Address: 123 Goal Guru Lane, Productivity City, PC 12345
      </p> */}
    </div>
  );
};

export default Contact;
